import React from 'react';
import ReactDOM from 'react-dom';
import { ClientInitialState } from '../common/types.js';
import App from './App.js';
import Fallback from './Fallback.js';
import './styles.css';

const rootNodes = document.querySelectorAll('[data-company-profile-root]');

rootNodes.forEach((rootNode) => {
    const renderNode = rootNode.querySelector('[data-company-profile]');
    const dataNode = rootNode.querySelector('[data-company-profile-data]');
    if (renderNode && dataNode && dataNode.textContent) {
        const initialState: ClientInitialState = JSON.parse(
            dataNode.textContent,
        );
        if (initialState.renderFallback) {
            ReactDOM.hydrate(<Fallback />, renderNode);
        } else {
            ReactDOM.hydrate(<App {...initialState} />, renderNode);
        }
    } else {
        // eslint-disable-next-line no-lonely-if
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.log('missing app and/or data element');
        }
    }
});
